import { Link } from "react-router-dom";
import { filmNews } from "@/mocks/news";
import { getFilmById, formatDate } from "@/lib/films";

export default function NewsSection() {
  const latest = filmNews.slice(0, 6);

  return (
    <section className="bg-background-100">
      <div className="mx-auto w-full max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
          <div>
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">最新影视动态</h2>
            <p className="mt-2 text-sm text-foreground-600">获奖、定档、口碑与幕后，第一时间掌握影视圈新鲜事。</p>
          </div>
        </div>

        <ul className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-2">
          {latest.map((item) => {
            const film = getFilmById(item.filmId);
            return (
              <li key={item.id}>
                <Link
                  to={`/detail/${item.filmId}`}
                  className="group flex h-full gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-accent-300 md:p-5"
                >
                  <div className="h-20 w-16 shrink-0 overflow-hidden rounded-md bg-background-200 sm:h-24 sm:w-20">
                    {film && (
                      <img src={film.poster} alt={`${film.title}海报`} className="h-full w-full object-cover object-top" />
                    )}
                  </div>
                  <div className="flex flex-1 flex-col">
                    <div className="flex items-center gap-2">
                      <span className="rounded-md bg-accent-100 px-2 py-0.5 text-xs font-medium text-accent-800">{item.tag}</span>
                      <time className="text-xs text-foreground-500">{formatDate(item.date)}</time>
                    </div>
                    <h3 className="mt-2 font-heading text-base font-semibold leading-snug text-foreground-950 line-clamp-2 group-hover:text-accent-700">
                      {item.title}
                    </h3>
                    <p className="mt-1.5 hidden text-sm leading-relaxed text-foreground-600 line-clamp-2 sm:block">
                      {item.summary}
                    </p>
                  </div>
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}